var map = {
	"./bg/erys.jpg": "WidP",
	"./bg/kenrig.jpg": "Lt0S",
	"./bg/lepetitballon.jpg": "5JIf",
	"./bg/mesplaques.jpg": "MeO5",
	"./bg/prohibition.jpg": "C7Yv",
	"./erys.jpg": "j492",
	"./kenrig.jpg": "GXUP",
	"./lepetitballon.jpg": "qmsx",
	"./mesplaques.jpg": "NCwC",
	"./prohibition.jpg": "YqAU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6gh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects ^\.\/.*\.jpg$
// module id = b6gh
// module chunks = 1